import { Lookup } from './lookup.interface';

//used on the proceed page when applying on behalf of someone else
export const AishSigningAuthority: { [name: string]: Lookup } = {
  powerOfAttorney: {
    code: 'powerOfAttorney',
    displayValue: 'Yes - I have a Power of Attorney or Trusteeship order for them',
  },

  parentGuardian: {
    code: 'parentGuardian',
    displayValue: `Yes - I'm their parent or guardian AND they are under 18 years old`,
  },

  none: {
    code: 'none',
    displayValue: `No - I'm helping them, but none of these apply to me`,
  },
};

//follow up question when the applicant selected powerOfAttorney
export const AishSigningAuthorityWorkRelated: { [name: string]: Lookup } = {
  yes: {
    code: 'yes',
    displayValue: 'Yes - I do this professionally, for example as a lawyer, accountant, or professional trustee',
  },

  no: {
    code: 'no',
    displayValue: `No - I'm doing this for a family member, friend, or someone else I know`,
  },
};

//follow up question when the applicant selected none
export const AishSigningAuthorityApplicantCanSign: { [name: string]: Lookup } = {
  yes: {
    code: 'yes',
    displayValue: 'Yes - they can review and sign it themselves',
  },

  no: {
    code: 'no',
    displayValue: 'No - they cannot understand what they are signing',
  },
};
